export default __webpack_public_path__ + "static/media/main.ebe736ef.jpg";